import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IResponsible } from '../interfaces/iresponsible';
import { environment } from './../environments/environment';
import { IFatura } from './../interfaces/ifatura';
import { catchError, firstValueFrom, Observable, throwError } from 'rxjs';
import { IAgendaEduAccessInfo } from '../interfaces/iagenda-edu-access-info';
import { LogService } from './log.service';
import { Fatura } from '../utils/fatura';
import { IAgendaEduLog } from '../interfaces/iagenda-edu-log';

@Injectable({ providedIn: 'root' })
export class ResponsibleService {
  apiBaseUrl: string = environment.apiBaseUrl;

  constructor(private http: HttpClient, private logService: LogService) {}

  verifyIsFinancialResponsible(
    accessInfo: IAgendaEduAccessInfo
  ): Observable<IResponsible> {
    return this.http
      .get<IResponsible>(
        `${this.apiBaseUrl}students/${accessInfo.studentToken}/responsible/${accessInfo.responsibleToken}/currentAcademicYearPermissions`,

        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessInfo.accessToken}`,
          },
        }
      )
      .pipe(catchError(this.handleError));
  }

  private handleError(err: any): Observable<never> {
    let errorMessage: string;
    if (err.error instanceof ErrorEvent) {
      errorMessage = `Ocorreu o seguinte erro ao acessar a verificação de responsável: ${err.error.message}`;
    } else {
      errorMessage = `Backend retornou o seguinte status ${err.status} ao acessar a verificação de responsável`;
    }
    return throwError(() => new Error(errorMessage));
  }

  getResponsibleDataStored(): IResponsible {
    let responsibleDataParsed!: IResponsible;
    const storedItem = sessionStorage.getItem('responsibleData');
    if (storedItem && storedItem != 'null' && storedItem != 'undefined') {
      responsibleDataParsed = JSON.parse(storedItem);
    }
    return responsibleDataParsed;
  }

  setResponsibleDataStored(value: IResponsible) {
    sessionStorage.setItem('responsibleData', JSON.stringify(value));
  }

  async getResponsibleData(
    accessInfo: IAgendaEduAccessInfo,
    urlOrigem: string
  ): Promise<IResponsible | null> {
    try {
      const responsibleData = await firstValueFrom(
        this.verifyIsFinancialResponsible(accessInfo)
      );
      return responsibleData;
    } catch (e: any) {
      this.treatErrorGetResponsible(e, urlOrigem);
      return null;
    }
  }

  private treatErrorGetResponsible(e: any, urlOrigem: string) {
    let message: string = '';
    if (e !== null) {
      message =
        typeof e === 'object' && e.hasOwnProperty('message') ? e.message : '';
    }
    this.logAcesso(urlOrigem, message);
  }

  logAcesso(urlOrigem: string, message: string) {
    let acessoListagemLog: IAgendaEduLog = {
      responsibleToken: '',
      studentToken: '',
      message: message,
      category: Fatura.categoryAcessoListagem,
      urlOrigem: urlOrigem,
      bankSlipAgendaEdu: null,
    };

    this.logService.logAgendaEdu(acessoListagemLog).subscribe();
  }
}
